module.exports = __webpack_public_path__ + "static/shopping-91f0a3509139cc427924009dd2c849ab.gif";